import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { StylesProvider, useToken } from '@rexlabs/styling';
import { PrimaryIconButton } from '@rexlabs/button';
import ActionMenuSvg from '@rexlabs/icons/medium/more-horizontal.svg';
var tokens = {
  button: {
    icon: {
      height: function height(_ref) {
        var token = _ref.token;
        return token('actionMenu.button.height', '3.2rem');
      },
      minWidth: function minWidth(_ref2) {
        var token = _ref2.token;
        return token('actionMenu.button.width', '3.2rem');
      }
    }
  }
};
export var ActionMenuButton = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var isOpen = _ref3.isOpen,
      IconProp = _ref3.Icon,
      props = _objectWithoutProperties(_ref3, ["isOpen", "Icon"]);

  var token = useToken();
  var Icon = IconProp !== null && IconProp !== void 0 ? IconProp : token('actionMenu.button.icon.svg', ActionMenuSvg);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(PrimaryIconButton, _extends({}, props, {
    ref: ref,
    Icon: Icon
  })));
});
ActionMenuButton.displayName = 'ActionMenuButton';
export default ActionMenuButton;